import breakpoints from '../../theme/breakpoints'
import theme from '../../theme/news12'

import css from 'styled-jsx/css'

export default css.global`
    
  .article {
    display: flex;
  }
  
  .article h1, .article h2, .article h3, .article h4, .article h5, .article h6 {
    border: 0;
    font-style: normal;
    font-size: 1.89em;
    font-weight: 600;
    line-height: 1.18em;
    padding: 0;
    margin-bottom: 16px;
    text-transform: initial;
    text-align: left;
  }

  .playlist-title {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 3px solid ${theme.colors.turbo};
    width: 100%;
    margin-bottom: 12px;
  }
  
  .more-stories {
    width: 100%;
    font-family: Graphik;
    font-style: normal;
    font-weight: bold;
    font-size: 13px;
    line-height: 17px;
    letter-spacing: 0.05em;
    color: ${theme.colors.navy}
  }

  .playlist-container h2 {
    font-family: Graphik;
    font-style: normal;
    font-weight: 500;
    font-size: 26px;
    line-height: 100%;
    margin-bottom: 7px;
    margin-top: 5px;
    width: 50%;
  }
  
  .see-all {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    width: 50%;
    text-align: right;
    font-family: Graphik;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    color: ${theme.colors.lightBlue};
    margin-top: 11px;
    margin-bottom: 7px;
  }
  
  .see-all a {
    cursor: pointer;
    padding-right: 4px;
  }
  
  .see-all a:hover {
    color: ${theme.colors.blueHover};
  }
  
  .banner-middle {
    margin: 0 -30px 50px -30px;
  }

  .article embed {
    max-width: 100%;
    margin-bottom: 12px;
  }

  .article blockquote {
    margin: 0 0 36px 0;
    padding: 5px 0px 5px 40px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .article blockquote:before {
    content: "";
    height: 100%;
    width: 24px;
    background: #E3E500;
    position: absolute;
    left: 0;
  }

  .article .twitter-tweet {
    margin-left: auto;
    margin-right: auto;
  }

  .article .twitter-tweet:before {
    background: transparent;
    width: 0;
  }

  .article blockquote > p {
    font-weight: 500;
    font-size: 28px;
    line-height: 38px;
    color: ${theme.colors.codGray};
    margin: 0;
  }

  .article blockquote > footer {
    font-size: 16px;
    line-height: 24px;
    color: ${theme.colors.zambezi};
  }

  .article blockquote > footer:before {
    content: '-';
    margin-right: 5px;
  }

  .byline {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    font-family: Graphik;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    overflow: hidden;
    margin-bottom: 16px;
    line-height: 135%;
    color: ${theme.colors.lightGray4};
  }

  .public-at:after {
    content: '•';
    margin: 0px 8px 0px 8px;
  }

  .date-byline {
    display: block;
    margin-bottom: 20.5px;
    font-weight: normal;
  }

  .author {
    font-weight: 600;
    color: ${theme.colors.mineShaft};
  }

  .author:before {
    font-weight: 400;
  }

  .byline .text {
    padding-right: 0.4em;
  }

  .share-icons {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
  }

  .share-icons span {
    font-family: Graphik;
    font-style: normal;
    font-weight: bold;
    font-size: 19px;
    line-height: 150%;
    text-align: center;
    margin-bottom: 16px;
  }
  
  .share-icons .social a {
    width: 40px;
    height: 40px;
  }
  
  .social {
    display: flex;
    margin-bottom: 16px;
  }

  .social a {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 0.9em;
    width: 32px;
    height: 32px;
    border-width: 1px 0 1px 1px;
    border-style: solid;
    border-color: ${theme.colors.lightGray};
    color: ${theme.colors.mineShaft};
    text-align: center;
  }

  .caption, .image em {
    display: block;
    font-weight: 400;
    font-size: 16px;
    text-align: center;
    margin: 10px 0 18px 0;
  }

  .social a:last-child {
    border-width: 1px;
  }

  .social a.twitter:hover {
    color: ${theme.colors.social.twitter};
  }

  .social a.facebook-f:hover {
    color: ${theme.colors.social.facebook};
  }

  .social svg {
    margin: 0 auto;
  }

  .article img, .article img + em {
    display: block;
    margin: 0 auto 20px auto;
  }

  .article-body-video, .article-body-video + em {
    display: block;
    margin: 0 auto 30px auto;
    width: 100;
  }

  .article img + em, .article embed + em, .article-body-video + em {
    font-size: 0.89em;
    font-style: normal;
    font-weight: 300;
    line-height: 1.5em;
    color: ${theme.colors.zambezi};
  }

  .article img + em:after, .article embed + em:after, .article-body-video + em:after {
    display: block;
    content: '';
    border-bottom: 1px solid ${theme.colors.sapphire};
    padding-top: 15px;
    margin-bottom: 30px;
  }

  .article .hero {
    margin-bottom: 30px;
  }

  .article .hero img {
    width: 100%;
  }

  .article a:hover {
    text-decoration: underline;
  }

  .playlist-container a:hover {
    text-decoration: none;
  }

  .block, .list {
    font-size: 1em;
    font-weight: 300;
    line-height: 1.5em;
    margin-bottom: 30px;
  }

  .article div.embed {
    margin: 0 auto 30px auto;
    max-width: 100%;
  }

  .article .carousel-embed {
    width: 100%;
    height: 690px;
  }

  .article .form-embed {
    width: 100%;
    height: 770px;
  }
  
  .banner-top {
    margin: 24px auto 12px;
  }

  // Article Ad Postscript
  .article .container.horizontal .banner-postscript-area {
    margin: 10px auto 30px;
    width: fit-content;
  }
  
  .facebook-embed {
    text-align: center;
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    .section.article-content {
      width: 100vw;
      padding: 12px 24px;
      overflow-x: hidden;
    }
    
    .vimeo-embed iframe, .youtube-embed iframe{
      height: 200px !important;
    }
  }
  
  @media only screen and (min-width: ${breakpoints.sm}px) {
    .section.article-content {
      padding: 12px 40px;
      overflow-x: hidden;
      width: 100vw;
    }
    
    .article .carousel-embed {
      width: 100%;
      height: 768px;
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    .container.horizontal.normal.article {
      background-color: ${theme.colors.drWhite};
    }
    
    .mobile-background-wrapper {
      background-color: ${theme.colors.white};
      overflow-x: hidden;
      padding: 0 40px;
      margin: 0 -40px;
      padding-top: 24px;
    }
    
    .banner-middle {
      padding-top: 24px;
      margin-bottom: 30px;
    }
    
    .wtw-wrapper .collection-title-container {
      padding: 0px;
    }
  }

  @media only screen and (min-width: ${breakpoints.md}px) {
    .section.article-content {
      padding: 12px 80px;
      overflow-x: hidden;
      width: 100vw;
    }
  
    .article .carousel-embed {
      width: 100%;
      height: 826px;
    }
  }
  
  @media only screen and (min-width: 808px) {
    .banner-leaderboardNew {
      width: 728px !important;
      height: 90px !important;
    }
  }

  @media only screen and (min-width: ${breakpoints.lg}px) {
    .article .section:first-of-type {
      width: 640px;
      padding: 12px 0;
    }
    
    .article .section.article-content {
      width: 640px;
      float: left;
      display: inline-block;
    }
    
    .article .carousel-embed {
      width: 100%;
      height: 790px;
    }

    .banner-top {
      max-width: 640px;
      margin: 24px 0 12px;
    }
  
    // Article Container
    .article .container.horizontal {
      display: block;
    }
    
    // Article Main Body
    .article .container.horizontal .article-content {
      padding: 12px 0;
    }
    
    // Article Ad Sidebar
    .article .container.horizontal .sidebar {
      display: inline-block;
      padding: 0;
      padding-left: 24px;
      float: right;
      width: fit-content;
      position: sticky;
      top: 121px;
    }
    
    // Article Ad Sidebar in unsupported browsers
    @supports not (position: sticky) {
      .article .container.horizontal .sidebar {
        position: fixed;
        top: 230px;
        right: 0;
      }
    }
    
    // Article Ad Sidebar
    .article .container.horizontal .sidebar .banner-sidebar-area {
      margin: 0 auto 45px;
    }
  }

  // Minute.ly width override (double classed for extra specificity):
  .editor-tv-wrapper.editor-tv-wrapper {
    max-width: calc(100vw - 43px);
  }
  
  .jpx-is-wrapper {
    max-width: calc(100vw - 43px);
    }
  }
  
  @media only screen and (min-width: 1280px) {
    .article .section:first-of-type {
      width: 720px;
    }
    
    .article .section.article-content {
      width: 720px;
    }
    
    .article .container.horizontal .sidebar {
      padding-left: 40px;
    }
    
    .banner-top {
      max-width: 720px;
      margin: 24px 0 12px;
    }
  }
`
